// extracted by mini-css-extract-plugin
module.exports = {"error":"FormValidator_error__IezMX","span":"FormValidator_span__3egHu","simpleBorder":"FormValidator_simpleBorder__2LkZC"};